import SpotlightAPI from './spotlight-api';

export default SpotlightAPI;
